import React from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import "./Tooltip.scss";

interface TooltipProps {
  label: string;
  children: React.ReactElement;
  side?: "top" | "bottom";
}

/**
 * Accessible tooltip for icon-only controls (hover and keyboard focus).
 */
export function Tooltip({
  label,
  children,
  side = "top",
}: TooltipProps): React.ReactElement {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className="tooltip__content"
          side={side}
          sideOffset={4}
        >
          {label}
          <RadixTooltip.Arrow className="tooltip__arrow" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}

export default Tooltip;
